export function isCommunityWithinRange(baseLocation, community, range = 1000) {
    var _a, _b;
    if (!baseLocation || !range) {
        return false;
    }
    if (!((_a = community === null || community === void 0 ? void 0 : community.address) === null || _a === void 0 ? void 0 : _a.latitude) || !((_b = community === null || community === void 0 ? void 0 : community.address) === null || _b === void 0 ? void 0 : _b.longitude)) {
        console.log("Latitude or Longitude is missing for community => ", community.name, " (", community._id, ")");
        return true;
    }
    const { latitude: baseLat, longitude: baseLong } = baseLocation;
    const { address: { latitude: communityLat, longitude: communityLong }, } = community;
    const distance = getDistanceFromLatLonInMiles(baseLat, baseLong, communityLat, communityLong);
    return distance <= range;
}
export function getDistanceFromLatLonInMiles(baseLat, baseLong, communityLat, communityLong) {
    const toRad = (value) => (value * Math.PI) / 180;
    const R = 3958.8; // Radius of the earth in miles
    const dLat = toRad(communityLat - baseLat);
    const dLong = toRad(communityLong - baseLong);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(baseLat)) * Math.cos(toRad(communityLat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in miles
    return parseFloat(distance.toFixed(2));
}
